export default __webpack_public_path__ + "static/media/ic-invisibility_2black.d88ef7b1.svg";